{
  "familyId": "SWW-VD-HOMOFOON",
  "questions": [
    {
      "id": "SWW-VD-HOMOFOON-001",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft: 'Als ik het ... (weten), had ik het gezegd.' Welke werkwoordsvorm past?",
      "options": ["had geweten", "wist", "weet", "geweten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voltooid Verleden Tijd",
            "content": "Voltooid verleden tijd: had/was + voltooid deelwoord. Voorbeeld: had geweten, was gegaan. Gebruik deze tijd als iets in het verleden al klaar was vóór iets anders.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "all_tenses_mix",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De journalist herkent: de zin beschrijft iets dat in het verleden had kunnen gebeuren ('Als ik het ..., had ik het gezegd'). Dit vraagt om voltooid verleden tijd: had + voltooid deelwoord. Het voltooid deelwoord van 'weten' is 'geweten'. Dus: had geweten.",
        "solutionSteps": [
          "De zin beschrijft iets in het verleden → voltooid verleden tijd",
          "Voltooid verleden tijd = had/was + voltooid deelwoord",
          "Voltooid deelwoord van 'weten' = geweten",
          "Antwoord: had geweten"
        ],
        "distractorExplanations": {
          "0": "Goed! Voltooid verleden tijd: had + voltooid deelwoord = had geweten.",
          "1": "Je dacht waarschijnlijk dat de gewone verleden tijd hier past. Maar 'wist' is de gewone verleden tijd. De constructie 'Als ik het ... had ik ...' vraagt om voltooid verleden tijd: had geweten. Onthoud: 'had ... had' = voltooid verleden tijd.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'weet' is tegenwoordige tijd, terwijl de zin het verleden beschrijft ('had ik het gezegd'). Onthoud: kijk naar de andere werkwoorden in de zin.",
          "3": "Je dacht waarschijnlijk dat 'geweten' alleen genoeg is. Maar de voltooid verleden tijd heeft altijd een hulpwerkwoord nodig: had geweten, niet alleen geweten. Onthoud: voltooid deelwoord gaat altijd samen met had/was."
        }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-002",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Een corrector controleert een tekst. Klik op het woord met een word/wordt-fout:",
      "context": "Ik wordt morgen jarig.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Ik wordt morgen jarig.",
        "correctHighlights": [{"start": 3, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Word vs. Wordt",
            "content": "Bij 'ik' gebruik je alleen de stam: ik word (zonder t). Bij hij/zij/het voeg je -t toe: hij wordt. Vervang door 'smurfen': 'Ik smurf' (niet 'Ik smurft') → dus: ik word.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_confusion",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De corrector ziet de fout: bij 'ik' gebruik je alleen de stam: ik word (zonder t). 'Ik wordt' is fout — de -t hoort er niet bij 'ik'. Vervang door 'smurfen': 'Ik smurf morgen jarig' (niet 'Ik smurft') → dus: ik word.",
        "solutionSteps": [
          "Onderwerp = 'ik' → stam zonder -t",
          "Stam van 'worden' = 'word'",
          "Ik word (zonder t), niet 'ik wordt'",
          "Check met smurfen: 'Ik smurf' klinkt goed ✓"
        ],
        "distractorExplanations": {
          "1": "Goed! 'Wordt' moet 'word' zijn bij 'ik'. Bij 'ik' gebruik je alleen de stam zonder -t: ik word."
        }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-003",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Een redacteur leest een artikel na. Klik op het woord met een word/wordt-fout:",
      "context": "Hij word steeds sterker door te sporten.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Hij word steeds sterker door te sporten.",
        "correctHighlights": [{"start": 4, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Word vs. Wordt",
            "content": "Bij hij/zij/het voeg je -t toe: hij wordt. Vervang door 'smurfen': 'Hij smurft' (met t) klinkt goed, dus: hij wordt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_hij_form",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De redacteur ziet de fout: bij 'hij' voeg je altijd -t toe. De stam 'word' + t = wordt (dt). Vervang door 'smurfen': 'Hij smurft steeds sterker' (met t) klinkt goed → dus: hij wordt.",
        "solutionSteps": [
          "Onderwerp = 'hij' → stam + t",
          "Stam van 'worden' = 'word'",
          "word + t = wordt (dt)",
          "Check met smurfen: 'Hij smurft' klinkt goed ✓"
        ],
        "distractorExplanations": {
          "1": "Goed! 'Word' moet 'wordt' zijn. Bij hij voeg je -t toe: word + t = wordt."
        }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-004",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Een schrijver controleert haar manuscript. Klik op het woord met een word/wordt-fout:",
      "context": "Het word tijd om te gaan.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Het word tijd om te gaan.",
        "correctHighlights": [{"start": 4, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Word vs. Wordt",
            "content": "Bij 'het' voeg je -t toe: het wordt. Vervang door 'smurfen': 'Het smurft' (met t) klinkt goed, dus: het wordt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_het_form",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De schrijver ziet de fout: bij 'het' voeg je altijd -t toe. De stam 'word' + t = wordt (dt). Vervang door 'smurfen': 'Het smurft tijd' (met t) klinkt goed → dus: het wordt.",
        "solutionSteps": [
          "Onderwerp = 'het' → stam + t",
          "Stam van 'worden' = 'word'",
          "word + t = wordt (dt)",
          "Check met smurfen: 'Het smurft' klinkt goed ✓"
        ],
        "distractorExplanations": {
          "1": "Goed! 'Word' moet 'wordt' zijn. Bij 'het' voeg je -t toe: word + t = wordt."
        }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-005",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "Een advocaat schrijft een brief: 'De verdachte ... (worden) vrijgesproken door de rechter.' Welke vorm past?",
      "options": ["werd", "word", "wordt", "geworden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verleden tijd van 'worden'",
            "content": "De verleden tijd van 'worden' is: ik/hij/zij werd, wij/zij werden. 'De verdachte' = hij/zij → werd. Let op: 'werd' (enkelvoud) vs. 'werden' (meervoud).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "worden_past_tense",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De advocaat herkent: de zin beschrijft iets in het verleden (vrijgesproken door de rechter). 'De verdachte' = hij/zij → verleden tijd enkelvoud: werd. Niet 'word' (stam) of 'wordt' (tegenwoordige tijd).",
        "solutionSteps": [
          "De zin beschrijft het verleden → verleden tijd",
          "'De verdachte' = hij/zij → enkelvoud",
          "Verleden tijd enkelvoud van 'worden' = werd",
          "Antwoord: De verdachte werd vrijgesproken"
        ],
        "distractorExplanations": {
          "0": "Goed! De verleden tijd enkelvoud van 'worden' is 'werd'.",
          "1": "Je dacht waarschijnlijk dat de stam hier past. Maar 'word' is de stam (ik-vorm tegenwoordige tijd). De zin beschrijft het verleden, dus: werd. Onthoud: kijk of de zin over het verleden gaat.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'wordt' is tegenwoordige tijd. De zin beschrijft iets dat al gebeurd is (vrijgesproken), dus verleden tijd: werd. Onthoud: 'vrijgesproken' wijst op het verleden.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'geworden' hoort bij 'is geworden'. Hier staat geen hulpwerkwoord 'is', dus gewoon verleden tijd: werd. Onthoud: voltooid deelwoord = altijd met hulpwerkwoord."
        }
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-006",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "werkwoorden",
      "subSkill": "ww_vd_homofoon",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst. Tik op een fout woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De jongen word altijd opgehaald door zijn moeder. Gisteren heefd hij zelf gefietst. Hij vind dat veel leuker.",
        "errors": [
          { "word": "word", "position": 2, "correction": "wordt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (wordt)" },
          { "word": "heefd", "position": 10, "correction": "heeft", "rule": "Onregelmatig werkwoord hebben: hij heeft" },
          { "word": "vind", "position": 15, "correction": "vindt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (vindt)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam + t bij hij/zij/het",
            "content": "Bij hij, zij of het in de tegenwoordige tijd gebruik je altijd de stam + t. Dus: hij wordt, hij vindt. Ook als de stam al op een -d eindigt!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "homofoon_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij 'hij' of 'de jongen' gebruik je in de tegenwoordige tijd altijd de stam + t. Dus: hij wordt, hij vindt. Het werkwoord 'hebben' is onregelmatig: hij heeft (niet heefd).",
        "solutionSteps": [
          "De jongen (hij) + worden (tegenwoordige tijd) = wordt",
          "Hij + hebben = heeft",
          "Hij + vinden (tegenwoordige tijd) = vindt"
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-011",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst. Let op: word/wordt, vind/vindt, verwart/verward.",
      "correctAnswer": null,
      "data": {
        "text": "Hij word steeds beter in spelling. Ze heeft het antwoord al gevonden, maar ze vind het moeilijk om uit te leggen. Het probleem wordt nu opgelost.",
        "errors": [
          { "word": "word", "correction": "wordt", "startIndex": 3, "endIndex": 7, "explanation": "Bij 'hij' in de tegenwoordige tijd: stam + t. Word + t = wordt." },
          { "word": "vind", "correction": "vindt", "startIndex": 86, "endIndex": 90, "explanation": "Bij 'ze' (enkelvoud) in de tegenwoordige tijd: stam + t. Vind + t = vindt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Homofonen: word/wordt, vind/vindt", "content": "Ik word (geen t), hij/zij wordt (wel t). Ik vind (geen t), hij/zij vindt (wel t). Check: vervang door een ander werkwoord. 'Hij loop' klinkt fout → 'hij loopt' → dus ook 'hij wordt'.", "icon": "lightbulb" } }
      ],
      "conceptId": "homofoon_error_spotting",
      "variantIndex": 11,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Twee fouten: 1) 'Hij word' → 'Hij wordt' (hij + stam + t). 2) 'ze vind' → 'ze vindt' (zij + stam + t). De laatste zin is correct: 'Het probleem wordt' (het + stam + t).",
        "solutionSteps": [
          "Check elk werkwoord: wie is het onderwerp?",
          "'Hij word' → hij = 3e persoon → wordt (stam + t)",
          "'ze vind' → zij = 3e persoon → vindt (stam + t)"
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-012",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "fill_in",
      "question": "Vul in: Het boek ... (worden) morgen bezorgd. Gebruik de tegenwoordige tijd.",
      "correctAnswer": "wordt",
      "data": {
        "acceptedAnswers": ["wordt"],
        "placeholder": "word of wordt?",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Word of wordt?", "content": "Bij 'het boek' (3e persoon enkelvoud): stam + t = wordt. Check: 'het boek loopt' → klinkt goed met -t → dus ook 'wordt'.", "icon": "lightbulb" } }
      ],
      "conceptId": "homofoon_fill_in_wordt",
      "variantIndex": 12,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Het boek' is 3e persoon enkelvoud (het). Bij hij/zij/het: stam + t = wordt. Check-strategie: vervang door 'lopen' → 'het boek loopt' → klinkt goed met -t → dus 'wordt'.",
        "solutionSteps": [
          "Onderwerp: 'het boek' = 3e persoon (het)",
          "Tegenwoordige tijd: stam + t",
          "Word + t = wordt"
        ]
      }
    }
  ]
}